export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen4_in-end.e3f4bb0f.jpg";